import { Field, Formik } from "formik";
import React from "react";
import {
  FieldInput,
  FieldDropSide,
  SearchableList,
  FieldButtonGroup,
  FieldInputSSN,
  FieldInputDecimal,
} from "../../../components";
import { required, yesNoOptions, getFormattedSsn } from "../../../utils";
import company from "../../../mocks/company.json";

const WithdrawalRequestOtherInformation = (props) => {
  const { fields, filteredValues } = props;
  return (
    <Formik>
      <div>
        <p className="mt-20 plan-sub-heading">Other Information</p>
        <Field
          size="sm"
          name={fields.pendingQDROIndicator}
          label={"Pending QDRO"}
          noLabelTransform
          options={yesNoOptions}
          // selectedValue={values[fields.pendingQDROIndicator]}
          value={filteredValues.pendingQDROIndicator}
          // onChange={(value) => {
          //   setFieldValue(fields.pendingQDROIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
        <Field
          size="md"
          name={fields.ownerShip}
          label={"Ownership %"}
          type="number"
          autoComplete="off"
          value={filteredValues.ownerShip}
          // onChange={handleChange}
          disabled={true}
          max={100}
          component={FieldInputDecimal}
        />
        <Field
          size="sm"
          name={fields.familyMemberOfOwnerIndicator}
          label={"Family Member of Owner ?"}
          options={yesNoOptions}
          // selectedValue={values[fields.familyMemberOfOwnerIndicator]}
          value={filteredValues.familyMemberOfOwnerIndicator}
          // onChange={(value) => {
          //   setFieldValue(fields.familyMemberOfOwnerIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
        <Field
          size="md"
          name={fields.relationUniquePersonalIdentification}
          label={"SSN of owner / family member"}
          noLabelTransform
          // type="text"
          autoComplete="off"
          value={getFormattedSsn(
            filteredValues.relationUniquePersonalIdentification
          )}
          // onChange={handleChange}
          disabled={true}
          component={FieldInput}
          maxLength="11"
        />
        <Field
          size="sm"
          name={fields.returnMailIndicator}
          label={"Return Mail Indicator ?"}
          options={yesNoOptions}
          // selectedValue={values[fields.returnMailIndicator]}
          value={filteredValues.returnMailIndicator}
          // onChange={(value) => {
          //   setFieldValue(fields.returnMailIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
        <Field
          size="sm"
          name={fields.officerIndicator}
          label={"Officer ?"}
          options={yesNoOptions}
          // selectedValue={values[fields.officerIndicator]}
          value={filteredValues.officerIndicator}
          // onChange={(value) => {
          //   setFieldValue(fields.officerIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
        <Field
          size="sm"
          name={fields.hceIndicator}
          label={"HCE ?"}
          noLabelTransform
          options={yesNoOptions}
          value={filteredValues.hceIndicator}
          // selectedValue={values[fields.hceIndicator]}
          // onChange={(value) => {
          //   setFieldValue(fields.hceIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
        <Field
          size="sm"
          name={fields.keyEmployeeIndicator}
          label={"Key Employee ?"}
          options={yesNoOptions}
          // selectedValue={values[fields.keyEmployeeIndicator]}
          value={filteredValues.keyEmployeeIndicator}
          // onChange={(value) => {
          //   setFieldValue(fields.keyEmployeeIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
        <Field
          size="md"
          name={fields.insiderOrRestrictedEmployeeIndicator}
          value={filteredValues.insiderOrRestrictedEmployeeIndicator}
          label="Insider / Restricted Employee ?"
          options={yesNoOptions}
          // selectedValue={values[fields.insiderOrRestrictedEmployeeIndicator]}
          // onChange={(value) => {
          //   setFieldValue(fields.insiderOrRestrictedEmployeeIndicator, value);
          // }}
          component={FieldButtonGroup}
          disabled={true}
        />
      </div>
    </Formik>
  );
};

export default WithdrawalRequestOtherInformation;
